import { render, staticRenderFns } from "./EmployeeInboxModalDischarge.vue?vue&type=template&id=280d39cc&"
import script from "./EmployeeInboxModalDischarge.vue?vue&type=script&lang=js&"
export * from "./EmployeeInboxModalDischarge.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeInboxModalDischarge.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports